module.exports = __webpack_public_path__ + "img/sigma.761cea77.svg";